import { useAuth } from "@clerk/nextjs"

export function useIsOrgAdmin(): boolean {
  const { orgRole } = useAuth()
  return orgRole === "org:admin"
}
